/* sg-product-card: contador de las tarjetas con estrella fuera del carrusel de más vendidos (ahí lo anima sg-bestsellers). */
(() => {
  if (window.__sgCardCountdown) return;
  window.__sgCardCountdown = true;

  const counters = () =>
    [...document.querySelectorAll('.sg-bs-card__counter[data-sg-card-end]')].filter((el) => !el.closest('sg-bestsellers'));

  const tick = () => {
    counters().forEach((el) => {
      const end = Date.parse(el.dataset.sgCardEnd);
      if (Number.isNaN(end)) return;
      const skew = el.dataset.sgCardNow ? Number(el.dataset.sgCardNow) * 1000 - Date.now() : 0;
      const total = Math.max(0, Math.floor((end - (Date.now() + skew)) / 1000));
      const parts = {
        days: Math.floor(total / 86400),
        hours: Math.floor((total % 86400) / 3600),
        minutes: Math.floor((total % 3600) / 60),
        seconds: total % 60,
      };
      el.querySelectorAll('[data-sg-cd]').forEach((tile) => {
        const num = tile.querySelector('.sg-cd__num');
        const text = String(parts[tile.dataset.sgCd]).padStart(2, '0');
        if (num && num.textContent !== text) num.textContent = text;
      });
    });
  };

  const start = () => {
    tick();
    setInterval(tick, 1000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
